import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import { FeedPage } from "./pages/FeedPage";
import { AuthCallback } from "./components/AuthCallback";
import { SettingsPage } from "./pages/SettingsPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { Analytics } from "@vercel/analytics/react";
import { trackEvent } from './config/amplitude';
import { FeedbackWidget } from './components/FeedbackWidget';

export default function App() {
  useEffect(() => {
    trackEvent('Page Viewed', {
      url: window.location.href
    });
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/feed" element={<FeedPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
        <FeedbackWidget />
      </div>
      <Analytics />
    </Router>
  );
}
